import { render, staticRenderFns } from "./IkPopup.vue?vue&type=template&id=674d6934&"
import script from "./IkPopup.vue?vue&type=script&lang=js&"
export * from "./IkPopup.vue?vue&type=script&lang=js&"
import style0 from "./IkPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports